import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative w-[358px] bg-white rounded-[4px] wide-scroller" }
const _hoisted_2 = { class: "px-[24px] pt-[16px] pb-[24px]" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "text-[20px] text-Text/text_high font-gordita-medium" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-times text-[24px] !mr-0" }, null, -1)
const _hoisted_6 = { class: "mt-[24px]" }
const _hoisted_7 = { class: "text-[12px] text-Text/text_medium" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "uil-copy mr-1.5" }, null, -1)

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton, useIncrediDialog } from 'incredi-ui';
import { useGettingStarted } from '@/views/getting-started/getting-started';
import { computed } from 'vue';
import { envConfig } from '@/services/features';
import { useCopyToClipboard } from '@/services/notify/copy-to-clipboard';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddAgentsForFreeDevLicenseDialog',
  setup(__props) {

const copyCommandToClipboard = useCopyToClipboard();
const dialog = useIncrediDialog();
const { invitationInstall } = envConfig;
const host = '{{host}}';
const port = '{{port}}';
const { hostAddress, ibManagerPort } = useGettingStarted();

const invitation = computed(() => invitationInstall.replace(host, hostAddress.value).replace(port, `${ibManagerPort.value}`));

const closeDialog = async () => {
  dialog?.close('addAgentsForFreeDevLicenseDialog');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('settings.dialogs.addAgentsForFreeDevLicense.title')), 1),
            _createVNode(_unref(IncrediButton), {
              size: "small",
              design: "ghost-grey",
              fab: "",
              class: "w-[32px] -mr-2",
              onClick: closeDialog
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('settings.dialogs.addAgentsForFreeDevLicense.body')), 1),
            _createVNode(_unref(IncrediButton), {
              design: "ghost-green",
              class: "mt-[8px]",
              size: "small",
              "data-testid": "add-agents-dialog-agents-link",
              disabled: !_unref(invitation),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(copyCommandToClipboard)(_unref(invitation))))
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createTextVNode(_toDisplayString(_ctx.$t('settings.dialogs.addAgentsForFreeDevLicense.linkText')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})